import React, { Component, Fragment } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import TransitionChild from '../common/TransitionChild';
import '../../css/react-css-transitions.scss';
import { Nav } from './Nav';
import { toggleScrollLock } from '../../utils';

export class NavOverlay extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.showNav !== this.props.showNav) {
      toggleScrollLock();
    }
  }

  render() {
    const {
      showNav, isMobile, onCloseButtonClick, pageData
    } = this.props;
    const navTransitionName = isMobile ? 'slide-x-rtl' : 'slide-x-ltr';
    const showHeaderCat = isMobile || (!isMobile && pageData.pageType === 'article');

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          key="global-nav-overlay"
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={250}
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}
          component={TransitionChild}>
          {showNav
            && <div className='nav-overlay' onClick={() => (!isMobile ? onCloseButtonClick() : null)}></div>
          }
        </ReactCSSTransitionGroup>

        <Nav
          onCloseClick={onCloseButtonClick}
          isMobile={isMobile} 
          showNav={showNav}
          showHeaderCat={showHeaderCat}/>
    
      </Fragment>
    );
  }
}

const mapStateToProps = ({ showNav, isMobile }) => ({
  showNav,
  isMobile,
});

export const mapDispatchToProps = dispatch => ({
  onCloseButtonClick: () => {
    dispatch({
      type: 'SIDEBAR_TOGGLE',
    });
  },
});

const NavContainer = connect(mapStateToProps, mapDispatchToProps)(NavOverlay);

export default NavContainer;
